import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { intlReducer } from 'react-intl-redux'
import loginReducer from './LoginReducer';
import accountReducer from './subAffiliate/AccountReducer';
import affiliatesReducer from './mainAffilate/AffiliatesReducer';
import domainsReducer from './mainAffilate/DomainsReducer';
import affUser from './mainAffilate/UsersReducer';
import languagesReducer from './settings/LanguagesReducer';
import currenciesReducer from './settings/CurrenciesReducer';
import getUserTypes from './mainAffilate/UsersReducer';
import playersReducer from './subAffiliate/PlayersReducer';
import signUpsReducer from './mainAffilate/SignUpsReducer';
import withdrawReducer from './mainAffilate/WithdrawReducer';
import reportReducer from './mainAffilate/ReportsReducer';
import controlsReducer from './controlsReducer';

const rootReducer = combineReducers({
  routing: routerReducer,
  controlsReducer: controlsReducer,
  intl: intlReducer,
  user: loginReducer,
  account: accountReducer,
  affUser: affUser,
  affiliates: affiliatesReducer,
  domains: domainsReducer,
  languages: languagesReducer,
  currencies: currenciesReducer,
  userTypes: getUserTypes,
  players: playersReducer,
  signUps: signUpsReducer,
  withdraw: withdrawReducer,
  reports: reportReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js